import VIEWS_NAMES from '@/router/viewsNames';
import steps from './steps';

export default {
  [steps.personalData]: VIEWS_NAMES.PERSONAL_DATA,
  [steps.address]: VIEWS_NAMES.ADDRESS,
  [steps.identificationDocument]: VIEWS_NAMES.IDENTIFICATION_DOCUMENT,
  [steps.academicFormation]: VIEWS_NAMES.ACADEMIC_FORMATION,
  [steps.financialSponsor.personalData]: VIEWS_NAMES.FINANCIAL_SPONSOR_PERSONAL_DATA,
  [steps.financialSponsor.identificationDocument]:
    VIEWS_NAMES.FINANCIAL_SPONSOR_IDENTIFICATION_DOCUMENT,
  [steps.financialSponsor.address]: VIEWS_NAMES.FINANCIAL_SPONSOR_ADDRESS,
  [steps.documents]: VIEWS_NAMES.DOCUMENTS,
  [steps.contract]: VIEWS_NAMES.CONTRACT,
  [steps.payment]: VIEWS_NAMES.PAYMENT,
  [steps.failPayment]: VIEWS_NAMES.RESULT,
  [steps.success]: VIEWS_NAMES.RESULT,
  [steps.pendingPayment]: VIEWS_NAMES.RESULT,
  [steps.accounts]: VIEWS_NAMES.ACCOUNTS,
  [steps.accountsResult]: VIEWS_NAMES.ACCOUNTS_RESULT,
};
